import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Image from '@/components/base/Image'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage, WPLink } from '@/types'

export type PushCardProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    icon: WPImage
    color: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    paragraph: string
    button: WPLink
  }>

const PushCard = ({
  color,
  icon,
  title,
  title_variant,
  title_component,
  paragraph,
  button,
  className,
  ...props
}: PushCardProps) => {
  return (
    <div
      className={cn([
        'flex h-full w-full flex-col space-y-[1rem] rounded-[3rem] bg-mainbody p-gutter text-center md:space-y-[1.5rem]',
        className
      ])}
      style={{ backgroundColor: color }}
      {...props}
    >
      {icon && icon.url ? (
        <div className="relative inline-flex h-[6rem] w-auto justify-center">
          <Image source={icon} className="h-full w-auto" />
        </div>
      ) : null}

      {title || paragraph ? (
        <div className="flex grow flex-col space-y-[1rem]">
          {title ? (
            <Typography
              variant={title_variant}
              component={title_component}
              className="text-white"
            >
              {title}
            </Typography>
          ) : null}

          {paragraph ? (
            <Typography variant="body" paragraph className="text-white">
              {paragraph}
            </Typography>
          ) : null}
        </div>
      ) : null}

      {button ? (
        <div className="flex">
          <Button variant="secondary" asChild className="grow">
            <Link href={button.url} target={button.target}>
              <span data-label={button.title} style={{ color }}>
                <Typography variant="label">{button.title}</Typography>
              </span>
            </Link>
          </Button>
        </div>
      ) : null}
    </div>
  )
}

export default PushCard
